// splide slider

import './js/helper.js'
import './js/gallery-slider.js'

import Splide from '@splidejs/splide';
window.Splide = Splide;

// show/hide member association box text
document.querySelectorAll('.associations-box').forEach(box => {
    const revealHide = box.querySelector('.reveal-hide');
    const revealHideWrap = box.querySelector('.reveal-hide-wrap');
    const desc = box.querySelector('.description');

    function isClamped() {
        desc.style.webkitLineClamp = 'unset';
        const naturalHeight = desc.scrollHeight;
        desc.style.webkitLineClamp = '';
        return naturalHeight > desc.clientHeight + 1;
    }

    function update() {
        if (desc.classList.contains('expanded')) {
            desc.classList.remove('expanded');
            if (isClamped()) {
                desc.classList.add('expanded');
                return;
            }
            desc.setAttribute('aria-expanded', 'false');
        }
        revealHideWrap.style.display = isClamped() ? '' : 'none';
    }

    revealHide.addEventListener('click', () => {
        const expanded = desc.classList.toggle('expanded');
        desc.setAttribute('aria-expanded', expanded);
        if (!expanded) update();
    });

    new ResizeObserver(() => update()).observe(box);
});